import { LANGUAGE_CODES } from './constants';

/**
 * Loads all translation definition files from a given webpack require.context.
 * Extracts the namespace from the filename and maps it to the JSON content.
 *
 * @param {__WebpackModuleApi.RequireContext} context - Webpack require.context for loading JSON files
 * @returns {Object.<string, Object>} Object mapping namespace names to their translation definitions
 *
 * @example
 * // Given files: ./en/common.json, ./en/assignment.json
 * // Returns: { common: {...}, assignment: {...} }
 */
function loadDefinitions(context) {
    return context.keys().reduce((acc, filePath) => {
        const namespace = filePath.split('/').pop().replace('.json', '');
        acc[namespace] = context(filePath);
        return acc;
    }, {});
}

/**
 * i18next resource bundle containing all translations organized by language code.
 * Each language contains namespaces (common, assignment, etc.) with their translations.
 *
 * @type {Object.<string, Object.<string, Object>>}
 *
 * Structure:
 * {
 *   en: {
 *     common: { key: "value", ... },
 *     assignment: { key: "value", ... }
 *   },
 *   es: {
 *     common: { key: "valor", ... },
 *     assignment: { key: "valor", ... }
 *   }
 * }
 */
export const resources = {
    [LANGUAGE_CODES.EN]: loadDefinitions(require.context('./en', false, /\.json$/)),
    [LANGUAGE_CODES.ES]: loadDefinitions(require.context('./es', false, /\.json$/)),
};
